

export interface ILanguage {

    [key: string]: string;

    uploadPhotosAndVideosDialogTitle : string;
    buttonSendPhotosAndVideos:string;
    buttonSendCamera:string;
    buttonSendDocument:string;
    menuSend: string;
    placeholderTypeAMessage:string;
    dropzoneDropHere:string;
    uploadDocumentDialogTitle:string;
    dropzoneDropHereNow: string;
    fileUploadGalleryItemNoPreviewAvailable: string;
}

const nl_NL : ILanguage = {
    uploadPhotosAndVideosDialogTitle:"Upload foto's & video's",
    buttonSendPhotosAndVideos:"Foto's en Video's",
    buttonSendCamera: "Camera",
    buttonSendDocument:"Document",
    menuSend:"Verstuur...",
    placeholderTypeAMessage:"Typ uw bericht.",
    dropzoneDropHere:"Sleep hier een bestand naartoe...",
    dropzoneDropHereNow:"Laat het bestand los",
    uploadDocumentDialogTitle:"Upload een document",
    fileUploadGalleryItemNoPreviewAvailable:"(geen voorbeeld)"
};

const en_US : ILanguage = {
    uploadPhotosAndVideosDialogTitle:"Upload Photos & Videos",
    buttonSendPhotosAndVideos:"Photos & Video's",
    buttonSendCamera: "Camera",
    buttonSendDocument:"Document",
    menuSend:"Send...",
    placeholderTypeAMessage:"Type a message.",
    dropzoneDropHere:"Drop a file here...",
    dropzoneDropHereNow:"Drop the file now",
    uploadDocumentDialogTitle:"Upload a document",
    fileUploadGalleryItemNoPreviewAvailable:"(preview not available)"
};


const dictionaries : { [key:string] : ILanguage  } = {
    nl_NL: nl_NL,
    en_US: en_US
}

export abstract class txt {

    public static get : ILanguage = nl_NL;

    public static language : string = "nl";

    public static setLanguage(iso: string) : string {
        var d = dictionaries[iso];
        if(d !== null) {
            txt.language = iso;
            txt.get = d;
        }
        return txt.language;
    }
    /*
    public static get(key: string) : string {
    
        var value: string =  txt.dictionary[key];

        if(!value) return '[n/a: ' + value.language + '::' + key + ']';

        return value;
    }*/

}